<script>
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: ['data', 'options'],
  data () {
    return {
      defaultOptions: {
        legend: {
          display: false
        },
        cutoutPercentage: 90,
        tooltips: {
          enabled: false
        }
      },
      defaultData: {
        datasets: [
          {
            label: '',
            borderWidth: 0,
            backgroundColor: ['#FF0050', '#f1f1f1'],
            data: [0, 100]
          }
        ]
      }
    }
  },
  mounted () {
    if (this.data) this.defaultData.datasets[0].data = this.data

    this.addPlugin({
      afterDatasetsDraw: function (chartInstance, easing) {
        if (chartInstance.config.type === 'doughnut') {
          var ctx = chartInstance.chart.ctx
          var rateLike = chartInstance.data.datasets[0].data[0]

          ctx.fillStyle = '#FF0050'
          var fontSize = 20
          var fontStyle = 'bold'
          var fontFamily = 'Helvetica Neue'
          // eslint-disable-next-line
          ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily)

          ctx.textAlign = 'center'
          ctx.textBaseline = 'middle'
          ctx.fillText(`興味あり ${rateLike.toString()}SW`, 100, 90)

          var rateTrash = chartInstance.data.datasets[0].data[1]

          ctx.fillStyle = 'grey'
          fontSize = 16
          fontStyle = 'normal'
          fontFamily = 'Helvetica Neue'
          // eslint-disable-next-line
          ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily)

          ctx.textAlign = 'center'
          ctx.textBaseline = 'middle'
          ctx.fillText(`興味なし ${rateTrash.toString()}SW`, 100, 120)
        }
      }
    })
    this.renderChart(this.defaultData, this.options || this.defaultOptions)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/share/DoughnutChartSwipe.vue